/**
 * Annual Report Navigation Handler
 *
 * Handles click events on [data-pdf-page] links.
 * If the PDF viewer is on the same page, scrolls to the page.
 * Otherwise, lets the link navigate normally with hash fragment.
 */

declare global {
  interface Window {
    arvInstance?: {
      scrollToPage: (pageNum: number) => void;
    };
  }
}

export default function annualReportNav(): void {
  const pdfPageLinks = document.querySelectorAll<HTMLAnchorElement>(
    '[data-pdf-page]'
  );

  pdfPageLinks.forEach((link) => {
    link.addEventListener('click', (e: Event) => {
      const pageNum = parseInt(link.getAttribute('data-pdf-page') || '1', 10);

      // Check if we're on the same page as the viewer
      if (window.arvInstance && pageNum >= 1) {
        e.preventDefault();
        window.arvInstance.scrollToPage(pageNum);

        // Update active state
        pdfPageLinks.forEach((l) => l.classList.remove('is-active'));
        link.classList.add('is-active');
      }
      // Otherwise, let the link navigate normally (with hash)
    });
  });
}
